import React, { Component } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { Link } from 'react-router-dom'
import './breadCrumb.css'
import { Button } from "antd";




export default class BreadCrumb extends Component {
    render() {
        return (
            <>
                <Row className="section breadcrumb">
                    {/* <Col><label className="breadcrumb"><Link to="/wallet" className="mr-2 p-0">Minha Wallet</Link> > <Link className="ml-2 p-0" to={this.props.link}>{this.props.page}</Link></label></Col> */}
                    <div><Button className="btnSaldo btnVoltarNegativo ml-1 pt-1"><Link to="/meusinvestimentos" className="btnLinkColor">Voltar</Link></Button></div>
                </Row>
            </>
        )
    }
}